import { GET_LIST, DETAIL } from "../../api/presence/presence";

const state = {
  list: [],
  detail: {},
  columns: [
    {
      label: "Employee Name",
      field: "user_name",
    },
    {
      label: "Location",
      field: "location_name",
    },
    {
      label: "Access Type",
      field: "access_type",
    },
    {
      label: "Access Time",
      field: "access_time",
    }
  ],
};
const mutations = {
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_DETAIL: (state, payload) => {
    state.detail = payload;
  },
};
const actions = {
  GET_LIST: async ({ commit }, args) => {
    const resp = await GET_LIST();
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  DETAIL: async ({ commit }, args) => {
    const resp = await DETAIL(args.id);
    const data = resp.data.data;
    commit("SET_DETAIL", data);
  },
};
const getters = {
  list: (state) => state.list,
  detail: (state) => state.detail,
  columns: (state) => state.columns,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
